import { render } from "./QimenPalace.vue?vue&type=template&id=1bbd2ce2"
import script from "./QimenPalace.vue?vue&type=script&lang=js"
export * from "./QimenPalace.vue?vue&type=script&lang=js"

import "./QimenPalace.vue?vue&type=style&index=0&id=1bbd2ce2&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__